function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.64848 7.66391C3.64848 7.66391 6.00012 8.83974 6.00012 7.27198C6.00012 5.85881 3.64848 6.55169 3.64848 5.31228C3.64848 4.13645 5.21624 4.13646 6.00012 4.92035",
  stroke: "#556677",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.82031 8.52466L4.82031 3.82138",
  stroke: "#556677",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.60938 6.23242C8.60938 8.30349 6.93044 9.98242 4.85938 9.98242C2.78831 9.98242 1.10938 8.30349 1.10938 6.23242C1.10938 4.16135 2.78831 2.48242 4.85938 2.48242C6.93044 2.48242 8.60938 4.16135 8.60938 6.23242Z",
  stroke: "#556677"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1575 14.4998H9.63117C9.15748 14.4998 8.78906 14.1314 8.78906 13.6577V12.3682C8.78906 11.8945 9.15748 11.5261 9.63117 11.5261H22.1575C22.6312 11.5261 22.9996 11.8945 22.9996 12.3682V13.6577C22.9996 14.1314 22.6312 14.4998 22.1575 14.4998Z",
  fill: "#556677"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.52631 14.4998H3.8421C3.36842 14.4998 3 14.1314 3 13.6577V12.3682C3 11.8945 3.36842 11.5261 3.8421 11.5261H5.52631C6 11.5261 6.36842 11.8945 6.36842 12.3682V13.6577C6.42105 14.1314 6 14.4998 5.52631 14.4998Z",
  fill: "#556677"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.52631 20.9999H3.8421C3.36842 20.9999 3 20.6315 3 20.1578V18.8946C3 18.4209 3.36842 18.0525 3.8421 18.0525H5.52631C6 18.0525 6.36842 18.4209 6.36842 18.8946V20.1578C6.42105 20.6315 6 20.9999 5.52631 20.9999Z",
  fill: "#556677"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1575 20.9999H9.63117C9.15748 20.9999 8.78906 20.6315 8.78906 20.1578V18.8946C8.78906 18.4209 9.15748 18.0525 9.63117 18.0525H22.1575C22.6312 18.0525 22.9996 18.4209 22.9996 18.8946V20.1578C22.9996 20.6315 22.6312 20.9999 22.1575 20.9999Z",
  fill: "#556677"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.1579 7.94363L11.8421 7.91802C11.3684 7.91802 11 7.55958 11 7.09871V5.79294C11 5.33208 11.3684 4.97363 11.8421 4.97363L22.1579 4.99924C22.6315 4.99924 23 5.35769 23 5.81855V7.12432C23 7.58518 22.6315 7.94363 22.1579 7.94363Z",
  fill: "#556677"
});
const SvgProfitsIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfitsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profits-icon.9049e881.svg";
export { ForwardRef as ReactComponent };